<template lang="pug">
  kakuzais-confirm-table(v-if="showConirmTable" :new_kakuzais="new_kakuzais" @showConfirmTable="showConfirmTable")
  section.section(v-else)
    .field.is-grouped.is-pulled-right
      .control
        button(@click="isSearchModalActive = true" class="button is-primary")
          b-icon(pack="fas" custom-class="fa-sm fa-search")
          span
            | 検索
        b-modal(:active.sync="isSearchModalActive" has-modal-card)
          search-kakuzai-modal(:formProps.sync="formProps" @on-search="onSearch")
      .control
        button(class="button is-primary" @click="exportCSV")
          b-icon(pack="fas" custom-class="fa-sm fa-download")
          span
            | 処理
      .control
        button(@click="isModalCsvImportActive = true" class="button is-primary")
          b-icon(pack="fas" custom-class="fa-sm fa-file-import")
          span
            | CSVインポート
        b-modal(:active.sync="isModalCsvImportActive" has-modal-card)
          modal-csv-import-form(@importCsvArray="importCsvArray" downloadPath="/Kakuzai_CSV_upload_template.csv")
    .field
      b-table(
        :data="new_kakuzais"
        narrowed
        hoverable
        paginated
        per-page="10"
        :loading="loading"
        id="kakuzai-register-table"
      )
        template(slot-scope="props")
          b-table-column(field="isbn" label="書籍名(代表)" width="200")
            isbn-input(
              :input_name="'isbn' + props.row.i"
              v-model="props.row.isbn"
              :books="books"
              :errors="errors"
            )
          b-table-column(field="code" label="帳合: 取次書店コード" class="shop-code" width="270")
            agency-shop-code-input(
              :input_name="'agency_shop_code' + props.row.i"
              :agency_code.sync="props.row.agency_code"
              :agency_shop_code.sync="props.row.agency_shop_code"
              :agencies="agencies"
              :final_book_shop_agencies="final_book_shop_agencies"
              :errors="errors"
              )
          b-table-column(field="banse" label="番線" width="150")
            b-field
              b-input(
                type="string"
                size="is-small"
                data-vv-as="番線"
                v-model="props.row.bansen"
              )
          b-table-column(field="bibo" label="備考" width="500")
            b-field
              b-input(
                type="string"
                size="is-small"
                data-vv-as="備考"
                v-model="props.row.bibo"
              )
          b-table-column(field="shop_person" label="書店担当者" width="120")
            b-field
              b-input(
                type="string"
                size="is-small"
                v-model="props.row.shop_person"
                data-vv-as="書店担当"
              )
          b-table-column(field="sales_person" label="営業担当者" width="120")
            sales-person-id-input(
                :input_name="'sales_person_id' + props.row.i"
                v-model="props.row.sales_person_id"
                data-vv-as="営業担当"
                :sales_people="sales_people"
                :data_vv_scope="'row' + props.row.i"
                :errors="errors"
          )
          b-table-column(v-show="kakuzai_single")
            button(@click="submit" class="button is-danger") 登録
    .field(v-if="!kakuzai_single")
      .control
        button(@click="confirm" class="button is-danger") 確認する
    .field(v-show="kakuzais_exist")
      div
        b-switch(v-model="allCheckboxSelected" class="table-header-switch has-text-white" @input="toggleAllCheckboxes") ステータス
      .scroll-table.table-border
        b-table(
          :loading="loading"
          :data="kakuzais"
          paginated
          hoverable
          striped
          icon-pack="fa"
          :current-page="page"
          :per-page="perPage"
          :total="total"
          @page-change="onPageChange"
          backend-pagination
        )
          template(slot-scope="props")
            b-table-column(field="ステータス" label="" width="130")
              b-checkbox(v-model="props.row.checked" :id=`'checkbox' + props.row.i`)
            b-table-column(field="isbn" label="書籍名(代表)" width="400")
              | {{ bookName(props.row.isbn) }}
            b-table-column(field="bibo" label="備考" width="300")
              | {{ props.row.bibo }}
            b-table-column(field="book_shop_name" label="書店名" width="170")
              | {{ props.row.final_book_shop_name }}
            b-table-column(field="shop_person" label="書店担当者" width="100")
              | {{ props.row.shop_person }}
            b-table-column(field="zip_code" label="郵便番号" width="100")
              | {{ props.row.zip_code }}
            b-table-column(field="address" label="住所" width="350")
              | {{ fullAddress(props.row.main_address, props.row.sub_address) }}
            b-table-column(field="agency_code" label="帳合" width="100")
              | {{ agencyName(props.row.agency_code)}}
            b-table-column(field="agency_shop_code" label="取次書店コード" width="120")
              | {{ props.row.agency_shop_code }}
            b-table-column(field="bansen" label="番線" width="80")
              | {{ props.row.bansen }}
            b-table-column(field="sales_person" label="営業担当者" width="100")
              | {{ salesPersonName(props.row.sales_person_id) }}
            b-table-column(field="created_at" label="登録日" width="100")
              | {{ formatDate(props.row.created_at)}}
            b-table-column(field="processed_at" label="処理日" width="100")
              | {{ formatDate(props.row.processed_at) }}
            b-table-column(field="" label="削除" width="60")
              b-field
                button.delete(@click="destroy(props.row.id)")
</template>

<script>
  import Kakuzai from 'models/kakuzai'
  import IsbnInput from 'inputs/isbn_input'
  import AgencyShopCodeInput from 'inputs/agency_shop_code_input'
  import SalesPersonIdInput from 'inputs/sales_person_id_input'
  import CacheDispatcher from 'mixins/cache_dispatcher'
  import SearchKakuzaiModal from 'components/kakuzais/search_kakuzai_modal'
  import ModalCsvImportForm from 'components/accepting_orders/modal_csv_import_form'
  import KakuzaisConfirmTable from 'components/kakuzais/kakuzais_confirm_table'
  import ErrorDisplayer from 'mixins/error_displayer'

  export default {
    name: 'multiple-kakuzais-field',
    mixins: [CacheDispatcher, ErrorDisplayer],
    components: {
      IsbnInput,
      AgencyShopCodeInput,
      SalesPersonIdInput,
      SearchKakuzaiModal,
      ModalCsvImportForm,
      KakuzaisConfirmTable
    },
    data() {
      return {
        loading: false,
        new_kakuzais: [new Kakuzai()],
        kakuzais: [],
        formProps: {
          created_on_gteq: this.$moment().add(-30, 'days').toDate(),
          created_on_lteq: this.$moment().toDate(),
          book_name_cont: '',
          agency_shop_code_cont: '',
          final_book_shop_name_cont: '',
          user_name_cont: '',
          only_unprocessed: true
        },
        isSearchModalActive: false,
        isModalCsvImportActive: false,
        page: 1,
        perPage: 100,
        total: 0,
        allCheckboxSelected: false,
        showConirmTable: false,
        errors: []
      }
    },
    computed: {
      books(){  return this.$store.getters['Books/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      final_book_shop_agencies(){ return this.$store.getters['FinalBookShopAgencies/records'] },
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
      kakuzai_single() { return this.new_kakuzais.length == 1 },
      kakuzais_exist() { return this.kakuzais.length > 0 }
    },
    methods: {
      bookName(isbn) {
        const book = this.books.find(book => book.isbn == isbn)
        return book ? book.name : ''
      },
      fullAddress(main_address, sub_address) {
        let address = ''
        if(main_address) address += main_address
        if(sub_address) address = address + " " + sub_address
        return address
      },
      agencyName(agency_code) {
        const agency = this.agencies.find(agency => agency.code == agency_code)
        return agency ? agency.name : ''
      },
      salesPersonName(sales_person_id) {
        const sales_person = this.sales_people.find(sales_person => sales_person.id == sales_person_id)
        return sales_person ? sales_person.name : ''
      },
      formatDate(datetime) {
        return datetime ? this.$moment(datetime).format("YYYY/MM/DD") : ''
      },
      shopCode(kakuzai) {
      },
      setData(kakuzai) {
        const final_book_shop_agency = this.final_book_shop_agencies.find(agency => agency.agency_code == kakuzai.agency_code && agency.agency_shop_code == kakuzai.agency_shop_code)
        if(!final_book_shop_agency) return

        kakuzai.shop_code = final_book_shop_agency.shop_code
        if(!kakuzai.bansen) kakuzai.bansen = final_book_shop_agency.book_sorting_work_code
      },
      submitRequest(url) {
        const method = 'post'
        this.new_kakuzais.forEach(kakuzai =>{
          this.setData(kakuzai)
        })
        const params = {
          multiple_kakuzai: {
            kakuzais_attributes: this.new_kakuzais,
          }
        }
        return this.$http({ method: method, url: url, data: params })
      },
      submit() {
        this.loading = true
        this.errors = []
        const url = '/api/v1/multiple_kakuzais.json'
        this.submitRequest(url).then(({data}) => {
          if(data.errors && data.errors.length > 0) {
            this.$toast.open({
              message: '登録に失敗しました。正しく情報を入力してください。',
              type: 'is-danger',
              position: 'is-bottom',
            })
            this.addErrors(data.errors)
            this.loading = false
            return
          }
          this.loadAsyncData()
          this.new_kakuzais = [new Kakuzai()]
          this.loading = false

          this.$toast.open({
            message: '登録に成功しました。',
            type: 'is-danger',
            position: 'is-bottom',
          })
        })
        .catch((error) => {
          this.loading = false
          this.$toast.open({
            message: '登録に失敗しました。',
            type: 'is-danger',
            position: 'is-bottom',
          })
          throw error
        })
      },
      confirm() {
        this.loading = true
        const url = '/api/v1/multiple_kakuzais/confirm.json'
        this.submitRequest(url).then(({data}) => {
          if(data.success) {
            this.loading = false
            this.showConfirmTable(true)
            return
          }
          this.$toast.open({
            message: '確認に失敗しました。正しく情報を入力してください。',
            type: 'is-danger',
            position: 'is-bottom',
          })
          this.addErrors(data.errors)
          this.sortByError()
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toast.open({
            message: '確認に失敗しました。',
            type: 'is-danger',
            position: 'is-bottom',
          })
          throw error
        })
      },
      addErrors(errors) {
        this.errors = []
        errors.forEach(error => {
          Object.keys(error).forEach(key => {
            this.errors.push({
            // accpeting_order_items.isbn0 なら isbn0にする
              field: key.replace(/.*\./g, ''),
              msg: error[key],
              i: key.replace(/[^0-9]/g, '')
            })
          })
        })
      },
      sortByError() {
        let rows_with_error = Array.from(new Set(this.errors.map(error => Number(error.i))))
        // エラーを含むものを配列の前に持ってくる
        this.new_kakuzais.sort(function(a, b) {
          if(rows_with_error.includes(a.i) && !rows_with_error.includes(b.i)) {
            return -1
          }
          if(!rows_with_error.includes(a.i) && rows_with_error.includes(b.i)) {
            return 1
          }
          return 0
        })
      },
      loadAsyncData() {
        const params = [
          `page=${this.page}`,
          `per_page=${this.perPage}`,
          Object.keys(this.formProps).map((key) => {
            return `q[${key}]=${this.formProps[key]}`
          }).join('&')
        ].join('&')

        this.loading = true
        this.$http.get(`/api/v1/kakuzais?${params}`)
          .then(({data}) => {
            this.kakuzais = []
            data['kakuzais'].forEach((kakuzai) => {
              this.kakuzais.push(new Kakuzai(kakuzai))
            })
            this.total = data.total_results
            this.loading = false
          })
          .catch((error) => {
            this.loading = false
            this.kakuzais = []
            throw error
          })
      },
      exportCSV() {
        this.loading = true
        let kakuzais = this.kakuzais.filter(kakuzai => kakuzai.checked)

        if(kakuzais.length == 0) {
          this.loading = false
          this.makeToast('処理の対象を選択してください。')
          return
        }

        kakuzais.forEach(kakuzai => kakuzai.processed_at = this.$moment().toDate())

        const params = {
          multiple_kakuzai: {
            kakuzais_attributes: kakuzais
          }
        }
        this.$http.patch(`/api/v1/multiple_kakuzais.json`, params)
            .then(({data}) => {
              this.allCheckboxSelected = false
              this.loadAsyncData()

              let allData = []
              data.kakuzais.forEach((kakuzai) => {
                allData.push(Object.assign({}, new Kakuzai(kakuzai)))
              })

              let csv = '\ufeff' + '書籍名,ISBN,備考,書店名,書店担当者,郵便番号,住所,副住所,帳合,取次書店コード,番線,営業担当者,入力者,登録日,処理日\n'
              allData.forEach(el => {
                csv += [
                  this.bookName(el['isbn']),
                  el['isbn'],
                  el['bibo'],
                  el['final_book_shop_name'],
                  el['shop_person'],
                  el['zip_code'],
                  el['main_address'],
                  el['sub_address'],
                  this.agencyName(el['agency_code']),
                  el['agency_shop_code'],
                  el['bansen'],
                  this.salesPersonName(el['sales_person_id']),
                  el['user_name'],
                  this.formatDate(el['created_at']),
                  this.formatDate(el['processed_at'])
                ].join(',') + '\n'
              })
              let blob = new Blob([csv], { type: 'text/csv' })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = 'Kakuzai.csv'
              link.click()
            })
            .catch((error) => {
              this.loading = false
              this.makeToast('CSVダウンロードに失敗しました。')
              throw error
            })
      },
      makeToast(message) {
        this.$toast.open({
          message: message,
          type: 'is-danger',
          position: 'is-bottom'
        })
      },
      onSearch() {
        this.onPageChange(1)
      },
      onPageChange(page) {
        this.page = page
        this.loadAsyncData()
      },
      destroy(id) {
        if(!confirm('拡材を削除しますか？')) return
        this.loading = true
        this.$http.delete(`/api/v1/kakuzais/${id}.json`).then((data) => {
          this.loading = false
          this.makeToast('削除に成功しました。')
          this.loadAsyncData()
        })
        .catch((error) => {
          this.loading = false
          this.makeToast('削除に失敗しました。')
          throw error
        })
      },
      toggleAllCheckboxes() {
        this.kakuzais.forEach(d => {
          d.checked = this.allCheckboxSelected
        })
      },
      importCsvArray(csv_array) {
        this.errors = []
        this.new_kakuzais = []
        csv_array.forEach((csv, i) => {
          this.new_kakuzais.push(Object.assign({}, Kakuzai.importCsvArray(csv, i)))
        })
      },
      showConfirmTable(value) {
        this.showConirmTable = value
      }
    },
    created() {
      this.loadAsyncData()
      this.$store.dispatch('Books/fetch', 'books')
      this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
      this.dispatch_with_cache('FinalBookShopAgencies/fetch', [ 'final_book_shop_agencies', null, { query: 'mode=simple' }], this.final_book_shop_agencies)
      this.dispatch_with_cache('SalesPeople/fetch', 'sales_people', this.sales_people)
      Kakuzai.initialize(
        {
          agencies: this.agencies,
          sales_people: this.sales_people
        }
      )
    }
  }
</script>

<style scoped>
.table-header-switch {
  position: relative;
  top: 40px;
  left: 9px;
  font-weight: bold;
}
</style>
